import {accessTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = accessTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const accessReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default accessReducer;
